module.exports = __webpack_public_path__ + "img/order-bg.dab54af5.svg";